/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetContractsPublicItemsContractIdNotFound
 */
export interface GetContractsPublicItemsContractIdNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetContractsPublicItemsContractIdNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetContractsPublicItemsContractIdNotFound interface.
 */
export function instanceOfGetContractsPublicItemsContractIdNotFound(value: object): value is GetContractsPublicItemsContractIdNotFound {
    return true;
}

export function GetContractsPublicItemsContractIdNotFoundFromJSON(json: any): GetContractsPublicItemsContractIdNotFound {
    return GetContractsPublicItemsContractIdNotFoundFromJSONTyped(json, false);
}

export function GetContractsPublicItemsContractIdNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContractsPublicItemsContractIdNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetContractsPublicItemsContractIdNotFoundToJSON(json: any): GetContractsPublicItemsContractIdNotFound {
    return GetContractsPublicItemsContractIdNotFoundToJSONTyped(json, false);
}

export function GetContractsPublicItemsContractIdNotFoundToJSONTyped(value?: GetContractsPublicItemsContractIdNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

